export type WidgetPosition = {
  horizontal: HorizontalPosition
  vertical: VerticalPosition
}

type HorizontalPosition = { align: "left" | "center" | "right"; offset: number }

type VerticalPosition = { align: "top" | "center" | "bottom"; offset: number }

export const DEFAULT_CONTACT_WIDGET_POSITION: WidgetPosition = {
  vertical: {
    align: "center",
    offset: 0,
  },
  horizontal: {
    align: "right",
    offset: 8,
  },
}

export const DEFAULT_FLOATING_ACTION_BUTTON_POSITION: WidgetPosition = {
  vertical: {
    align: "bottom",
    offset: 8,
  },
  horizontal: {
    align: "left",
    offset: 8,
  },
}

export const DEFAULT_STANDALONE_PROMPTS_POSITION: WidgetPosition = {
  vertical: {
    align: "bottom",
    offset: 8,
  },
  horizontal: {
    align: "left",
    offset: 8,
  },
}

export const getPositionStyle = (position: WidgetPosition) =>
  [
    position.vertical.align === "top"
      ? `top: ${position.vertical.offset}px`
      : "",
    position.vertical.align === "center"
      ? `top: calc(50% + ${position.vertical.offset}px); transform: translateY(-50%)`
      : "",
    position.vertical.align === "bottom"
      ? `bottom: ${position.vertical.offset}px`
      : "",
    position.horizontal.align === "left"
      ? `left: ${position.horizontal.offset}px`
      : "",
    position.horizontal.align === "center"
      ? `left: calc(50% + ${position.horizontal.offset}px); transform: translateX(-50%)`
      : "",
    position.horizontal.align === "right"
      ? `right: ${position.horizontal.offset}px`
      : "",
  ]
    .filter(Boolean)
    .join(";")

export const getFloatingActionPlacement = (position: WidgetPosition) => {
  switch (position.horizontal.align) {
    case "left":
      return "top-start"
    case "center":
      return "top"
    case "right":
      return "top-end"
  }
}
